export default () => (
  <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.73242 10.3354C5.34758 9.64324 7.1626 9.5999 8.80273 10.2056L9.12793 10.3354L10.9932 11.1353C11.8226 11.4907 12.3604 12.3061 12.3604 13.2085V15.0659C12.3602 15.2969 12.1734 15.4838 11.9424 15.4839H0.918945C0.687832 15.4839 0.500145 15.297 0.5 15.0659V13.2085C0.5 12.3625 0.972409 11.5924 1.71484 11.2065L1.86719 11.1353L3.73242 10.3354Z"
      stroke="#4451DE"
    />
    <circle cx="6.43037" cy="4.96065" r="3.17451" stroke="#4451DE" />
    <path d="M4.59279 9.55371L6.43004 15.9841L3.21484 12.3096L4.59279 9.55371Z" fill="#4451DE" />
    <path d="M8.26659 9.55371L6.42933 15.9841L9.64453 12.3096L8.26659 9.55371Z" fill="#4451DE" />
    <path
      d="M13.6417 0.758069C13.57 0.363346 13.8732 0 14.2744 0H16.5916C16.9928 0 17.2961 0.363346 17.2243 0.75807L16.1721 6.54543C16.1165 6.85119 15.8502 7.07344 15.5394 7.07344H15.3267C15.0159 7.07344 14.7496 6.85119 14.694 6.54543L13.6417 0.758069Z"
      fill="#4451DE"
    />
    <circle cx="15.4345" cy="9.6457" r="1.28608" fill="#4451DE" />
  </svg>
)
